<template>
  <BaseDialog
    :visible.sync="dialogVisible"
    :is-warn="true"
    :max-width="1400"
    title="下载中心"
    :need-confirm-text="false"
    cancel-text="关闭"
  >
    <DownloadList
      v-if="dialogVisible"
      :dialog-visible="dialogVisible"
    ></DownloadList>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/BaseDialog.vue'
import { computed } from 'vue'
import DownloadList from './DownloadList.vue'

export default {
  name: '',
  components: { BaseDialog, DownloadList },
  props: {
    hideDialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:hideDialogVisible'],
  setup(props, { emit }) {
    const dialogVisible = computed({
      get() {
        return props.hideDialogVisible
      },
      set(value) {
        emit('update:hideDialogVisible', value)
      },
    })

    return {
      dialogVisible,
    }
  },
}
</script>

<style lang="scss" scoped></style>
